import React from 'react';
import Legend from './legend';
import TabbedLegend from './tabbedLegend';

export default (props) => (props.tabbed ? <TabbedLegend {...props} /> : <Legend {...props} />);
